import { render, staticRenderFns } from "./roomDialog.vue?vue&type=template&id=1c52058c&scoped=true"
import script from "./roomDialog.vue?vue&type=script&lang=js"
export * from "./roomDialog.vue?vue&type=script&lang=js"
import style0 from "./roomDialog.vue?vue&type=style&index=0&id=1c52058c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c52058c",
  null
  
)

export default component.exports